module.exports = __webpack_public_path__ + "img/map-3.d3d50c3e.jpg";